// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"353":"a3b6f5f41ab37f68","952":"8f97a7c7d6898b0b"}[chunkId] + ".js";
};